import { stepTypeInts } from "@/utils/general";

const generalCountConfig = {
  type: 'number',
  sortable: true,
  total: "reduce"
}

const counts = {
  sms: {
    label: 'СМС отправлено',
    ...generalCountConfig
  },
  email: {
    label: 'Email сгенерировано',
    ...generalCountConfig
  },
  viber: {
    label: 'Viber отправлено',
    ...generalCountConfig
  },
  whatsapp: {
    label: 'WhatsApp отправлено',
    ...generalCountConfig
  },
  push: {
    label: 'Push отправлено',
    ...generalCountConfig
  },
  notification: {
    label: 'В новостную ленту отправлено',
    ...generalCountConfig
  },
  wallet: {
    label: 'Push Кошёлек',
    ...generalCountConfig
  },
  webpush: {
    label: 'Web Push',
    ...generalCountConfig
  },
  inapp: {
    label: 'In App',
    ...generalCountConfig
  },
  webhook: {
    label: 'Webhook',
    ...generalCountConfig
  },
  chatbot: {
    label: 'Чат-бот',
    ...generalCountConfig
  }
}

export default {
  columns: {
    Name: {
      label: 'Название',
      sortable: true,
      total: 'Итого:'
    },
    membersCount: {
      label: 'Участники',
      ...generalCountConfig
    }
  },
  childrenColumns: {
    SegmentName: {
      label: "Название сегмента"
    },
    SegmentID: {
      label: "ID сегмента"
    }
  },
  charts: {
    sms: { color: 'blue' },
    email: { color: "green" },
    viber: { color: 'blue' },
    whatsapp: { color: 'green' },
    push: { color: "green" },
    notification: { color: "green" },
    wallet: { color: 'violet' },
    webpush: { color: "green" },
    inapp: { color: 'blue' },
    webhook: { color: 'blue' },
    chatbot: { color: 'violet' }
  },

  formStepColumns: (availableSteps) => {
    if (!availableSteps) return counts;

    const res = {};
    availableSteps.forEach(s => {
      if (counts[s]) res[s] = { ...counts[s] }
    });
    return res;
  },

  getPiePercantageData: (data, key) => {
    return data[stepTypeInts[key]] ? {
      Count: data[stepTypeInts[key]].sent.Count,
      Percent: data[stepTypeInts[key]].delivered.Percent,
      Total: data[stepTypeInts[key]].sent.Total
    } : {};
  },

  generateAdditionalFields: i => {
    const { MsgStats } = i.Stats;
    const stepTypes = Object.entries(stepTypeInts);

    stepTypes.forEach(step => {
      i[step[0]] = MsgStats[step[1]] && MsgStats[step[1]].sent ? MsgStats[step[1]].sent.Count : 0;
    });
  },

  formChildren(segments, promotionID) {
    segments.forEach((i, index) => {
      i.ID = promotionID + index;
      i.Index = index;
      i.membersCount = i.Stats.ContactsCount;

      this.generateAdditionalFields(i);
    });
    return segments;
  }
}

